import React from "react";
import { Form, Button, message, Input } from "antd";
import { useAuth } from "../commons/contexts/auth-context";

function ForgotPassword(props) {
  const { forgotPassword } = useAuth();
  const { form } = props;

  function handleSubmit(e) {
    e.preventDefault();
    form.validateFields(async (err, values) => {
      if (!err) {
        try {
          //console.log(values);
          let res = await forgotPassword(values);
          message.success(res.message);
        } catch (e) {
          message.error(`${e.message}`);
        }
      }
    });
  }

  return (
    <div>
      <Form onSubmit={handleSubmit} className="password-form">
        <h2>Forgot Password</h2>
        <p className="alt-left">
          Enter your username and company info and we will send you a password
          reset link to the email registered on your account.
        </p>

        <Form.Item className="alt-left" label="Company URL">
          {form.getFieldDecorator("company_url", {
            rules: [
              { required: true, message: "Please input your company's URL" }
            ]
          })(<Input />)}
        </Form.Item>

        <Form.Item className="alt-left" label="Username">
          {form.getFieldDecorator("username", {
            rules: [{ required: true, message: "Please input your username" }]
          })(<Input />)}
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
          >
            Send password reset link
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
}
export default Form.create({ name: "forgot_password" })(ForgotPassword);
